import React, { useEffect } from 'react';
import moment from 'moment';
import SessionCard from '../SessionCard/SessionCard';
import { LoadingIcon, Button } from '@prosolve/common-components-ui'
import useDataSessions from '../../dataHooks/useDataSessions';
import useAttemptSessionDataMigration from '../../hooks/useAttemptSessionDataMigration';
import useCustomEventListener from '../../hooks/useCustomEventListener';
import { FaSync } from 'react-icons/fa';
import { checkHasEventTrainerPermissions, checkHasEditEventPermissions } from '../../utils';

export default ({
  filters,
  displayFilters = {},
  onSessionsChange = () => {},
  onSessionsLoadingChange = () => {},
  isStarSubdomain
}) => {

  const {
    isLoading,
    sessions,
    fetchSessions
  } = useDataSessions();

  useEffect(() => {
    onSessionsChange(sessions)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessions]) 

  useEffect(() => {
    onSessionsLoadingChange(isLoading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]) 

  useEffect(() => {
    fetchSessions(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  useCustomEventListener('reloadSessions', () => fetchSessions(filters));

  const filteredSessions = sessions.filter(({ 
    date = '', 
  }) => {
    let passedFilters = true;

    const dateFilter = displayFilters.date;

    if (dateFilter && dateFilter !== date) {
      passedFilters = false;
    }

    return passedFilters;
  })

  const { 
    isMigrationAttemptOccuring,
    attemptedManualSessionLoad,
    attemptSessionMigration,
    attemptInitialSessionFromEventTemplateLoad,
  } = useAttemptSessionDataMigration()
  
  const eventId = (filters && filters.eventId) || '';

  const hasMigrateAttemptPermissions = (checkHasEventTrainerPermissions() || checkHasEditEventPermissions())

  return (
    <div>
      {
        (isLoading || isMigrationAttemptOccuring) ?
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: '650px'
          }}>
            <div style={{ marginTop: '40px' }}>
              <LoadingIcon />
            </div>
          </div>
          :
          <div style={{
            flex: 1,
            display: 'flex',
            columnGap: '20px',
            rowGap: '20px',
            padding: '20px',
            flexWrap: 'wrap'
          }}>
            {
              filteredSessions.length > 0
              ?
              filteredSessions
              .sort(({ startTime: startTimeA }, { startTime: startTimeB }) => moment(startTimeA, 'hh:mm:ss') - moment(startTimeB, 'hh:mm:ss'))
              .map(session => <SessionCard key={session._id} sessionData={session} />)
              :
              (
                eventId && !attemptedManualSessionLoad && hasMigrateAttemptPermissions
                ?
                <div style={{
                  color: '#565656',
                  fontSize: '14px',
                }}>
                  <span>{'Missing expected session data? To attempt data sync click here:'}</span>
                  <Button
                    style={{
                      display: 'inline-flex',
                      border: 'none',
                      position: 'relative',
                      marginLeft: '10px' 
                    }}
                    onClick={() => {
                      if (isStarSubdomain) {
                        attemptInitialSessionFromEventTemplateLoad(eventId, () => window.dispatchEvent(new CustomEvent('reloadSessions', {})))
                      } else {
                        attemptSessionMigration(eventId, () => window.dispatchEvent(new CustomEvent('reloadSessions', {})))
                      }
                    }}
                  >
                    <span style={{ color: '#565656', fontSize: '16px' }}>{'Sync'}</span>
                    <FaSync style={{ marginLeft: '10px', color: '#0280c6', fontSize: '18px' }} />
                  </Button>
                </div>
                :
                <div style={{
                  color: '#565656',
                  fontSize: '14px',
                }}>
                  {'No sessions found'}
                </div>
              )
            }
          </div>
      }
    </div>
  )
}